import React, { useState, createContext, ReactNode } from 'react';

import { Modal } from '../components/Modal';

import { ModalPropsType, CommonContextType } from '../types/common.types';

export const CommonContext = createContext<CommonContextType>({});

export const CommonProvider = ({ children }: { children: ReactNode }) => {
  const [modal, openModal] = useState<ModalPropsType | null>(null);
  const closeModal = (): void => {
    openModal(null);
  };

  return (
    <CommonContext.Provider value={{ modal, openModal, closeModal }}>
      <Modal {...modal} onClose={closeModal} open={!!modal} />
      {children}
    </CommonContext.Provider>
  );
};
